import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["imported", "foreignKey", "validValues", "foreignKeyTable", "defaultValue", "primary", "required", "requiredHidden", "sensitive", "mask", "values"];

  connect() {
    //this.test1Target.textContent = "ConnectCalled";
    this.setOnConnect();
  }

  setOnConnect() {
    const isImported = this.importedTarget.checked;
    const isPrimary = this.primaryTarget.checked;

    //this.test2Target.textContent = "setOnConnectCalled";
    //this.test5Target.textContent = "isImported: " + isImported;
    //this.test6Target.textContent = "isPrimary: " + isPrimary;

    if (isImported || isPrimary) {
      this.validValuesTarget.disabled = true;
      this.validValuesTarget.value = "";

      this.foreignKeyTableTarget.disabled = true;
      this.foreignKeyTableTarget.value = "";

      this.defaultValueTarget.disabled = true;
      this.defaultValueTarget.value = "";
    }

    if (isPrimary) {
      // set required to true and disable if primary key is checked
      this.requiredTarget.checked = true;
      this.requiredTarget.disabled = true;
      this.requiredHiddenTarget.value = true;

      // set mask to blank and disable if primary key is checked
      this.maskTarget.value = "";
      this.maskTarget.disabled = true;
    } 

    // set validValues to disabled if foreignKeyTable is set
    if (this.foreignKeyTableTarget.value.trim() !== "") {
      this.validValuesTarget.disabled = true;
    }

    // set foreignKeyTable to disabled if validValues is set
    if (this.validValuesTarget.value.trim() !== "") {
      this.foreignKeyTableTarget.disabled = true;
    }
  }

  toggleFields() {
    const isImported = this.importedTarget.checked;
    const isPrimary = this.primaryTarget.checked;

    // Set visible text value for test1Target (a div)
    //this.test3Target.textContent = "toggleFieldsCalled";

    if (isImported || isPrimary) {
      this.validValuesTarget.disabled = true;
      this.validValuesTarget.value = "";

      this.foreignKeyTableTarget.disabled = true;
      this.foreignKeyTableTarget.value = "";

      this.defaultValueTarget.disabled = true;
      this.defaultValueTarget.value = "";
    } else {
      this.validValuesTarget.disabled = false;
      this.validValuesTarget.value = "";
      this.foreignKeyTableTarget.disabled = false;
      this.defaultValueTarget.disabled = false;
    }

    if (isPrimary) {
      // set required to true and disable if primary key is checked
      this.requiredTarget.checked = true;
      this.requiredTarget.disabled = true;
      this.requiredHiddenTarget.value = true;

      // set mask to blank and disable if primary key is checked
      this.maskTarget.value = "";
      this.maskTarget.disabled = true;
    } else {
      this.requiredTarget.disabled = false;
      this.requiredHiddenTarget.value = this.requiredTarget.checked;
      this.maskTarget.disabled = false;
    }
  }

  // New method: when foreignKeyTable is set disable & clear validValues, and vice versa.
  toggleExclusiveFields() {

    //this.test4Target.textContent = "toggleExclusiveCalled";

    if (this.foreignKeyTableTarget.value.trim() !== "") {
      this.validValuesTarget.disabled = true;
      this.validValuesTarget.value = "";
    } else {
      this.validValuesTarget.disabled = false;
    }
    if (this.validValuesTarget.value.trim() !== "") {
      this.foreignKeyTableTarget.disabled = true;
      this.foreignKeyTableTarget.value = "";
    } else {
      this.foreignKeyTableTarget.disabled = false;
    }
  }
}
